import backgroundRed from "@/assets/background_red.svg";
import decoratorRed from "@/assets/decorator_red.svg";
import AuthCard from "@/components/AuthCard";
import { brandEmail } from "@/lib/brand";
import type { UserOrigin } from "@/types";

type Props = {
  waitlist?: boolean;
  origin?: UserOrigin | null;
};

export default function Canceled({ waitlist = false, origin }: Props) {
  return (
    <AuthCard
      title="Inscripción anulada"
      subtitle={
        <>
          <strong className="font-semibold text-ink">
            {waitlist
              ? "Tu inscripción en la lista de espera ha sido anulada."
              : "Tu inscripción al curso ha sido anulada."}
          </strong>
          {!waitlist && (
            <>
              <br />
              {origin === "los_tilos" ? (
                <>
                  Para solicitar el reembolso del aporte realizado,{" "}
                  <a
                    href="https://forms.gle/gVKugKLJRHJeURXA9"
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    pincha aquí
                  </a>
                  .
                </>
              ) : (
                <>
                  Para solicitar el reembolso del aporte realizado, escribe a{" "}
                  {brandEmail(origin)}.
                </>
              )}
            </>
          )}
        </>
      }
      background={backgroundRed}
      decorator={decoratorRed}
    >
      {null}
    </AuthCard>
  );
}
